import { Inject, Injectable } from '@angular/core';
import { SourceAPI, SourceInterface } from '../..';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {mbeConfigService} from './mbe-config.service';
import { BasicResponse, SortFilterInterface } from '@auth-suite-services/services';

// This is the service to communicate to die REST.API relating to Source class/table
//                                                       27/11/2020 CGF

@Injectable({
  providedIn: 'root',
})
export class SourceService {
  // Use pre-defined environment
  private URL;
  headers: HttpHeaders;

  constructor(
    // See C001 - 2026-09-07 - HE
    // @Inject(mbeConfigService) private config,
    @Inject(mbeConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      // See C001 - 2026-09-07 - HE
      // config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
      config.REST_SERVER_url.find((restUrl: { api?: string; url?: string }) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllSou(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sortFilter: SortFilterInterface
  ): Observable<SourceAPI> {
    const headers = this.headers;
    // POST {} when filter undefined so backend gets valid JSON body. 15/09/2026 PK.
    // const body = sortFilter;
    const body =
      sortFilter && typeof sortFilter === 'object' && !Array.isArray(sortFilter)
        ? sortFilter
        : {};
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<SourceAPI>(
      `${this.URL}/sou/allsource/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}`,
      body,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  getSource(id: number): Observable<SourceInterface> {
    const headers = this.headers;
    return this.httpClient.get<SourceInterface>(
      `${this.URL}/sou/singlesource/${id}`,
      { headers }
    );
    return this.httpClient.get<SourceInterface>(
      `${this.URL}/sou/singlesource/${id}`,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  CreateSource(source: SourceInterface): Observable<BasicResponse> {
    const headers = this.headers;
    // API returns BasicResponse { status, summary, errors } not SourceInterface. 15/09/2026 PK.
    // return this.httpClient.post<SourceInterface>(
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/sou/createsource`,
      source,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  UpdateSource(source: SourceInterface): Observable<SourceInterface> {
    const headers = this.headers;
    return this.httpClient.post<SourceInterface>(
      `${this.URL}/sou/updatesource`,
      source,
      { headers }
    );
    return this.httpClient.post<SourceInterface>(
      `${this.URL}/sou/updatesource`,
      source,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Typed SourceService constructor config as any and REST_SERVER_url.find restUrl as { api?: string; url?: string }. Previous behavior: constructor parameters were untyped (implicit any), which failed Jest/ts-jest under noImplicitAny when source.service.spec.ts imported the service for AM ISSUE B HTTP tests. New behavior: config and restUrl have explicit types so the spec compiles. Reason: Enable AM ISSUE B unit tests that assert GET /sou/singlesource and POST /sou/allsource keep RecordDate/RecordTime. Context: Same InjectionToken pattern as FinancialService. Impact: Runtime URL construction unchanged. - 2026-09-07 - HE